import { axios } from "../lib/axios";

export const leadDone = async function (caseProgessId) {
  try {
    const response = await axios.put("case/leaddone", null, {
      header: { "Content-Type": "application/json" },
      params: { caseProgressId: caseProgessId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const leadProgressDone = async function (caseProgessId, userName) {
  try {
    const response = await axios.put("case/leaddone", null, {
      header: { "Content-Type": "application/json" },
      params: { caseProgressId: caseProgessId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const onlineConsultDone = async function (caseProgessId, userName) {
  try {
    const response = await axios.put("case/onlineconsultdone", null, {
      header: { "Content-Type": "application/json" },
      params: { caseProgressId: caseProgessId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const f2fConsultDone = async function (caseProgessId, userName) {
  try {
    const response = await axios.put("case/F2Fconsultdone", null, {
      header: { "Content-Type": "application/json" },
      params: { caseProgressId: caseProgessId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const sendToDesignDashboard = async function (caseId) {
  try {
    const response = await axios.put(
      "case/sendtodesigner",
      null,

      {
        header: { "Content-Type": "application/json" },
        params: {
          CaseId: caseId,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const approveDesign = async function (caseId) {
  try {
    const response = await axios.put("case/approvedesign", null, {
      header: { "Content-Type": "application/json" },
      params: { CaseId: caseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const collectPayment = async function (caseId, userName) {
  try {
    const response = await axios.put("booking/paymentcollection", null, {
      header: { "Content-Type": "application/json" },
      params: { CaseId: caseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const fabricateSet = async function (caseProgressId) {
  try {
    const response = await axios.put("case/fabricateset", caseProgressId, {
      header: { "Content-Type": "application/json" },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const shipSet = async function (caseProgressId) {
  try {
    const response = await axios.put("case/shipset", caseProgressId, {
      header: { "Content-Type": "application/json" },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const nextSets = async function (caseId) {
  try {
    const response = await axios.put("case/nextset", null, {
      header: { "Content-Type": "application/json" },
      params: { CaseId: caseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getCases = async function () {
  try {
    const response = await axios.get("case/getallcase");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getPaymentSummary = async function () {
  try {
    const response = await axios.get("case/getallpayment");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getCasesByDentistUserId = async function (userId) {
  try {
    const response = await axios.get(
      "case/getcasesbydentistuserid?userId=" + userId
    );
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getCasesByFilter = async function (model) {
  console.log(model);
  try {
    const response = await axios.get("case/getfilteredcases", {
      headers: {
        "Content-Type": "application/json",
      },
      params: model,
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addPatient = async function (model, userName) {
  try {
    const response = await axios.post("patient/addpatient", model, {
      headers: { "Content-Type": "application/json" },
      params: { userName: userName },
    });
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getCaseProgress = async (CaseId) => {
  try {
    const response = await axios.get("case/getcaseprogress", {
      params: { CaseId },
    });
    return response.data.data;
  } catch {}
};

export const getCaseProgressById = async (CaseProgressId) => {
  try {
    const response = await axios.get("case/getcaseprogressbyid", {
      params: { CaseProgressId },
    });
    return response.data.data;
  } catch {}
};

export const getOnlineConsultationInfo = async (CaseId) => {
  try {
    const response = await axios.get("case/getonlineconsultationinfo", {
      params: { CaseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getF2FConsultationInfo = async (CaseId) => {
  try {
    const response = await axios.get("case/getf2fconsultationinfo", {
      params: { CaseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getScanningInfo = async (CaseId) => {
  try {
    const response = await axios.get("case/getscanninginfo", {
      params: { CaseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getDesignInfo = async (CaseId) => {
  try {
    const response = await axios.get("case/getdesigninfo", {
      params: { CaseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getReviewDesignInfo = async (CaseId) => {
  try {
    const response = await axios.get("case/getreviewdesigninfo", {
      params: { CaseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getPaidCases = () => axios.get("case/getcaseswithpayment");

export const getCase = (caseId) =>
  axios.get("case/getcase", {
    params: { caseId },
  });

export const addDentistToCase = (caseId, dentistId) =>
  axios.put("case/" + caseId + "/dentist", { dentistId });

export const createCase = (data) => axios.post("booking/portal", data);

export const addAppointment = (caseId, appointmentDateTime) =>
  axios.put("booking/addappointment", {
    caseId,
    appointmentDateTime,
  });

export const submitCase = (formData) =>
  axios.post("case/submitcase", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const uploadFiles = (formData) =>
  axios.post("case/uploadfiles", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const scanningDone = (formData) => {
  return axios.put("case/scanningdone", formData, {
    header: { "Content-Type": "multipart/form-data" },
  });
};

export const updateDueDate = (model) => axios.post("case/updateduedate", model);

export const updateFabricationDate = (model) =>
  axios.put("case/updatefabricationdate", model);

export const updateShipmentDate = (model) =>
  axios.put("case/updateshipmentdate", model);

export const updateNoOfSets = (model) =>
  axios.post("case/updatenoofsets", model);

export const getSets = async (caseId) => {
  try {
    const response = await axios.get("case/getsets", {
      params: { caseId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const uploadScannedFiles = (caseId) =>
  axios.post("case/uploadscannedfiles", caseId);

export const updatePaymentInformation = async (model) =>
  await axios.put("case/updatepaymentinformation", model);

export const payCaseProgress = (model) =>
  axios.post("case/paycaseprogress", model);

export const manualPaymentWithCustomAmount = (model) =>
  axios.post("case/manualpaymentwithcustomamount", model);

export const getPaymentTransactionsByCaseId = async (caseId) => {
  try {
    const response = await axios.get("case/getpaymenttransactionsbycaseid", {
      params: { caseId },
    });

    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const submitDesign = (formData) =>
  axios.post("case/submitdesign", formData, {
    header: { "Content-Type": "multipart/form-data" },
  });

export const getDesign = (caseId) => axios.get("case/" + caseId + "/getDesign");

export const approveCaseDesign = (details) =>
  axios.post(`case/${details.caseId}/design/approve`, details);

export const terminateCase = (values) =>
  axios.post(`case/terminatecase`, values);

export const updateCaseTreatmentTypeAmount = (values) =>
  axios.post(`case/updatecasetreatmenttypeamount`, values);

export const rejectCaseDesign = (caseId, formData) =>
  axios.post(`case/${caseId}/design/reject`, formData, {
    header: { "Content-Type": "multipart/form-data" },
  });

export const getFiles = (caseId) => axios.get("file/case/" + caseId);
export const sendPaymentEmail = (caseProgressId, isSubscription) =>
  axios.post("case/sendpaymentemail", { caseProgressId, isSubscription });

export const sendPaymentEmailWithCustomAmount = (
  modeOfPayment,
  caseProgressId,
  amount,
) =>
  axios.post("case/sendpaymentemailwithcustomamount", {
    modeOfPayment,
    caseProgressId,
    amount,
  });

export const generatePaymentLink = (
  caseProgressId,
  modeOfPayment,
  isSubscription
) =>
  axios.post("case/generatepaymentlink", {
    caseProgressId,
    modeOfPayment,
    isSubscription,
  });

export const generatePaymentLinkWithCustomAmount = (
  modeOfPayment,
  caseProgressId,
  amount,
) =>
  axios.post("case/generatepaymentlinkwithcustomamount", {
    modeOfPayment,
    caseProgressId,
    amount,
  });

export const addComment = (
  caseProgressAppointmentId,
  caseProgressId,
  message
) =>
  axios.post("case/addcomment", null, {
    params: { caseProgressAppointmentId, caseProgressId, message },
  });

export const editComment = (commentId, message) =>
  axios.post("case/editcomment", null, {
    params: { commentId, message },
  });

export const getComments = (caseProgressAppointmentId) =>
  axios.get("case/getcomments", {
    params: { caseProgressAppointmentId },
  });

export const savePaymentLink = async (caseProgressId, link) =>
  await axios.post("case/savePaymentLink", null, {
    params: { caseProgressId, link },
  });

export const createSubscriptionPlan = (modeOfPayment, caseId, thruEmail) =>
  axios.post("case/createsubscriptionplan", {
    modeOfPayment,
    caseId,
    thruEmail,
  });

export const updateCaseTotalPrice = (caseId, amount) =>
  axios.post("case/updatecasetotalprice", { caseId, amount });

//to avoid expiration after 30 mins
export const generateNewSubscriptionLink = (modeOfPayment, caseId, thruEmail) =>
  axios.post("case/generatenewsubscriptionlink", {
    modeOfPayment,
    caseId,
    thruEmail,
  });

//change payment
export const changePayment = async (caseId) => {
  try {
    const response = await axios.post(
      '/case/changepayment',
      null,
      {
        params: {
          caseId: caseId
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};